
import { FormsFeatureContext, IDataSingleResponse } from '@ngt/forms';
import { useCallback, useContext } from 'react';
import { KeyedMutator } from 'swr';
import { LotProperty, LotPropertyPostRowEdit } from '../../api/dtos';

export const usePostLotPropertyEdit = (mutate?: KeyedMutator<IDataSingleResponse<LotProperty>>) => {
    const formsFeature = useContext(FormsFeatureContext);


    // @ts-ignore
    const save = useCallback(async (lotId?: number, propertyId?: number, value?: string, metadata?: Record<string, any>, shouldRevalidate?: boolean) => {
        if(!lotId || !propertyId) return false;
        const response: IDataSingleResponse<LotProperty> = await formsFeature.serviceStackClient.post(new LotPropertyPostRowEdit({ lotId: lotId, propertyId: propertyId, value: value}))

        return response?.data;
    }, [formsFeature.serviceStackClient, mutate]);

    return save;
};

export default usePostLotPropertyEdit;